export function getNodeEnv(): NodeEnvironment {
  return process.env.NODE_ENV
}

export function isDevelopmentEnvironment(): boolean {
  return getNodeEnv() === 'development'
}

export function isProductionEnvironment(): boolean {
  return getNodeEnv() === 'production'
}

export function isTestEnvironment(): boolean {
  return getNodeEnv() === 'test'
}
